


import { z } from "zod";
import { Chat, Message } from "../Chat";
import type { AssertSchemaMatchesClass } from "../../../utils/typeUtils";


const _MessageZod = z.object({
    id: z.string().default(""),
    sender: z.string().default("system"), 
    messageContent: z.string().default(""),
    sentDate: z.coerce.date().default(new Date())
})
// Assert that schema matches the class definition // Omit the methods from the class definition for the assertion
void (true as AssertSchemaMatchesClass<typeof _MessageZod, Omit<Message, "setDate" | "align">>);
export const MessageSchema = _MessageZod.transform((data) => new Message(data));


const _ChatZod = z.object({
    id: z.string().default(""),
    messages: z.array(MessageSchema).default([])
})
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _ChatZod, Chat>);
export const ChatSchema = _ChatZod.transform((data) => new Chat(data));


